import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SharedModule } from '@app/shared/shared.module';
import { CanDeactivateGuard } from '@app/base/shared';

import {
  ApplicantComponent,
  LocationComponent,
  TypeComponent,
  InformationComponent,
  AddressesComponent,
  PremiseComponent,
  CommercialPremiseComponent,
  ResidentialPremiseComponent,
  MixedPremiseComponent,
  ReviewComponent,
  AcknowledgeComponent
} from '@app/modules/applicant';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'residential/location' },  // Landing without defining any type, set the default one
  {
    path: ':type',
    component: ApplicantComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'location' },
      { path: 'location', component: LocationComponent, canDeactivate: [CanDeactivateGuard], data: { title: 'Applicant Request | Service Address' } },
      { path: 'type', component: TypeComponent, canDeactivate: [CanDeactivateGuard], data: { title: 'Applicant Request | Request Type' } },
      { path: 'information', component: InformationComponent, canDeactivate: [CanDeactivateGuard], data: { title: 'Applicant Request | About Applicant' } },
      { path: 'addresses', component: AddressesComponent, canDeactivate: [CanDeactivateGuard], data: { title: 'Applicant Request | Site Details' } },
      { path: 'premise', component: PremiseComponent, canDeactivate: [CanDeactivateGuard], data: { title: 'Applicant Request | Premise' } },
      { path: 'review', component: ReviewComponent, canDeactivate: [CanDeactivateGuard], data: { title: 'Applicant Request | Review Request' } },
      { path: 'acknowledge', component: AcknowledgeComponent, canDeactivate: [CanDeactivateGuard], data: { title: 'Applicant Request | Acknowledge' } },
    ]
  }
];

@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild(routes)
  ],
  declarations: [
    ApplicantComponent,
    LocationComponent,
    TypeComponent,
    InformationComponent,
    AddressesComponent,
    PremiseComponent,
    ReviewComponent,
    AcknowledgeComponent,
    CommercialPremiseComponent,
    ResidentialPremiseComponent,
    MixedPremiseComponent
  ]
})
export class ApplicantModule { }
